<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">

      <h2 class="ficha-title" :style="styles.colorBasic">Datos de la práctica</h2>

      <article class="group">

        <div class="contenedor-data" v-if="!!data.idPractica">
          <h4 class="data-title" :style="styles.colorBasic">Id Práctica</h4>
          <p>{{data.idPractica}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.nombreGestorOferta">
          <h4 class="data-title" :style="styles.colorBasic">{{(brand.encabezados.tutorados.nombreGestorOferta) ? brand.encabezados.tutorados.nombreGestorOferta.nombre : 'Nombre gestor' }}</h4>
          <p>{{data.nombreGestorOferta}}</p>
        </div>        

        <div class="contenedor-data -full" v-if="!!data.urlAnexo">
          <arrow-link :text="'Ver documento anexo de prácticas'" :to="data.urlAnexo" :external="true" :blank="true">
          </arrow-link>
        </div>

        <div class="contenedor-data -full" v-if="!!data.urlConvenio && !!brand.detallePractica.pestannaPractica.showUrlConvenioAsociado">
          <arrow-link :text="'Ver documento convenio asociado'" :to="data.urlConvenio" :external="true" :blank="true">
          </arrow-link>
        </div>

      </article>

      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">Detalles del puesto</h3>

        <div class="contenedor-data" v-if="!!data.tipoCreditos">
          <h4 class="data-title" :style="styles.colorBasic">Tipo de práctica</h4>
          <p>{{data.tipoCreditos}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.puesto">
          <h4 class="data-title" :style="styles.colorBasic">Nombre del puesto</h4>
          <p>{{data.puesto}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.areaFuncional">
          <h4 class="data-title" :style="styles.colorBasic">Área funcional</h4>
          <p>{{data.areaFuncional}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.ayudaAlEstudio">
          <h4 class="data-title" :style="styles.colorBasic">Ayuda al estudio</h4>
          <p>{{data.ayudaAlEstudio}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.funciones">
          <h4 class="data-title" :style="styles.colorBasic">Tareas a desarrollar</h4>
          <p v-html="data.funciones"></p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.tareas1">
          <h4 class="data-title" :style="styles.colorBasic">Tarea 1</h4>
          <p v-html="data.tareas1"></p>
        </div>
        <div class="contenedor-data -full" v-if="!!data.tareas2">
          <h4 class="data-title" :style="styles.colorBasic">Tarea 2</h4>
          <p v-html="data.tareas2"></p>
        </div>
        <div class="contenedor-data -full" v-if="!!data.tareas3">
          <h4 class="data-title" :style="styles.colorBasic">Tarea 3</h4>
          <p v-html="data.tareas3"></p>
        </div>
        <div class="contenedor-data -full" v-if="!!data.otrasTareas">
          <h4 class="data-title" :style="styles.colorBasic">Otras tareas</h4>
          <p v-html="data.otrasTareas"></p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.motivosSolicitudValidacion">
          <h4 class="data-title" :style="styles.colorBasic">Motivos de solicitud de Validación</h4>
          <p v-html="data.motivosSolicitudValidacion"></p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.urlAnexoProrroga">
          <arrow-link :text="'Ver documento de prórroga'" :to="data.urlAnexoProrroga" :external="true" :blank="true">
          </arrow-link>
        </div>

      </article>


      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">Duración</h3>

        <div class="contenedor-data" v-if="!!data.fechaInicio">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de inicio</h4>
          <p>{{data.fechaInicio}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.fechaFin">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de finalización</h4>
          <p>{{data.fechaFin}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.horario">
          <h4 class="data-title" :style="styles.colorBasic">Horario</h4>
          <p>{{data.horario}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.horasDia">
          <h4 class="data-title" :style="styles.colorBasic">Nº horas al día</h4>
          <p>{{data.horasDia}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.totalHoras">
          <h4 class="data-title" :style="styles.colorBasic">Horas totales</h4>
          <p>{{data.totalHoras}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.totalHoras">
          <h4 class="data-title" :style="styles.colorBasic">Días en semana</h4>
          <p>{{data.numDiasSemana}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.HorasCurriculares">
          <h4 class="data-title" :style="styles.colorBasic">Horas curriculares</h4>
          <p>{{data.HorasCurriculares}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.HorasExtracurriculares">
          <h4 class="data-title" :style="styles.colorBasic">Horas extracurriculares</h4>
          <p>{{data.HorasExtracurriculares}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.NumeroCreditos">
          <h4 class="data-title" :style="styles.colorBasic">Número de créditos</h4>
          <p>{{data.NumeroCreditos}}</p>
        </div>

      </article>


      <template v-if="data.nombreTutorEmpresa != null">

        <article class="group">

          <h3 class="group-title" :style="styles.colorBasic">Tutor/a en la empresa</h3>
          
          <div class="contenedor-data -full">
            <div class="full-children" v-if="data.nombreTutorEmpresa != null">
              <h4 class="data-title" :style="styles.colorBasic">Nombre</h4>
              <div class="contenedor-input">
                <input type="text" :style="styles.input_black" v-model="data.nombreTutorEmpresa">
              </div>
            </div>
            <div class="full-children" v-if="data.apellidosTutorEmpresa != null">
              <h4 class="data-title" :style="styles.colorBasic">Apellidos</h4>
              <div class="contenedor-input">
                <input type="text" :style="styles.input_black" v-model="data.apellidosTutorEmpresa">
              </div>
            </div>
            <div class="full-children" v-if="data.emailTutorEmpresa != null">
              <h4 class="data-title" :style="styles.colorBasic">Email</h4>
              <div class="contenedor-input">
                <input type="text" :style="styles.input_black" v-model="data.emailTutorEmpresa">
              </div>
            </div>
            <div class="full-children" v-if="data.telefonolTutorEmpresa != null">
              <h4 class="data-title" :style="styles.colorBasic">Teléfono</h4>
              <div class="contenedor-input">
                <input type="text" :style="styles.input_black" v-model="data.telefonolTutorEmpresa">
              </div>
            </div>
            <div class="full-children" v-if="data.cargoTutorEmpresa != null">
              <h4 class="data-title" :style="styles.colorBasic">Cargo</h4>
              <div class="contenedor-input">
                <input type="text" :style="styles.input_black" v-model="data.cargoTutorEmpresa">
              </div>
            </div>
            <div class="full-children" v-if="data.departamento != null">
              <h4 class="data-title" :style="styles.colorBasic">Departamento</h4>
              <div class="contenedor-input">
                <input type="text" :style="styles.input_black" v-model="data.departamento">
              </div>
            </div>
            <arrow-link v-if="!!brand.detallePractica.pestannaPractica.showCertificadoPracticas && !!data.urlCertificadoDePracticas" :text="'Generar certificado de prácticas'" 
              :external="true" :to="data.urlCertificadoDePracticas" :blank="true"></arrow-link>
          </div>

          <a class="btn add-datos-tutor -xs" :style="styles.solidPrimary" @click="guardarDatosTutorEmpresa()" :loading="loadingGuardarDatosTutorEmpresa"
              v-if="!showadddocumentacion">Guardar datos tutor</a>

        </article>

      </template>


        <article class="group" v-if="showCuestionarios">

          <h3 class="group-title" :style="styles.colorBasic">Cuestionarios</h3>

          <a v-if="!!data.idContestacionEncuestaTutorEmpresa"
            @click="$emit('setEncuesta',data.idContestacionEncuestaTutorEmpresa)"
            title="Consultar el cuestionario de la empresa" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Ver cuestionario de la empresa <only-arrow></only-arrow></a>

          <a v-if="!!data.idContestacionEncuestaAlumno" @click="$emit('setEncuesta',data.idContestacionEncuestaAlumno)"
            title="Consultar el cuestionario de la empresa" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Ver cuestionario del alumno/a <only-arrow></only-arrow></a>

          <a v-if="!!data.idContestacionEncuestaTutorAcademico" @click="$emit('setEncuesta',data.idContestacionEncuestaTutorAcademico)"
            title="Consultar el cuestionario del tutor académico" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Ver cuestionario del tutor/a académico/a <only-arrow></only-arrow></a>

          <a v-if="!!data.urlActillacalificacion" :href="data.urlActillacalificacion"
            target="_blank"
            title="Consultar actilla de calificación" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Ver actilla de calificación <only-arrow></only-arrow></a>

          <a v-if="!!data.urlDocEvaluacionTutor" :href="data.urlDocEvaluacionTutor"
            target="_blank"
            title="Consultar documento de Evaluación del tutor" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Documento de Evaluación del tutor/a <only-arrow></only-arrow></a>

            <div class="full-children" v-if="!!data.cuestionariosTutorAcademicoContestados && data.cuestionariosTutorAcademicoContestados.length != 0">
              <h4 class="data-title" :style="styles.colorBasic">Cuestionarios del tutor/a académico/a contestados</h4>
              <template v-for="el in data.cuestionariosTutorAcademicoContestados">
                <a @click="$emit('setEncuesta',el.clave)"
                :title="el.valor" class="row-start enlace-cuestionario"
                :style="styles.colorBasic">{{el.valor}} <only-arrow></only-arrow></a>
              </template>
            </div>

        </article>
        
      <article class="group" v-if="!!brand.detallePractica.pestannaPractica.showResultadosEncuestas && (totales.coordinadorDePractica || totales.tutorAcademico) &&
                                   !!data.cuestionariosQueVeElTutorAcademicoContestados && data.cuestionariosQueVeElTutorAcademicoContestados.length > 0">
                                   
        <h3 class="group-title" :style="styles.colorBasic">Resultado encuestas</h3>

        <div class="contenedor-data -full" v-for="encuesta in data.cuestionariosQueVeElTutorAcademicoContestados">
          <arrow-link :text="encuesta.valor" :to="encuesta.enlace" :external="true" :blank="true">
          </arrow-link>
        </div>

      </article>
        
      <article class="group" v-if="!!brand.detallePractica.pestannaPractica.showResultadosEncuestas && (totales.coordinadorDePractica || totales.tutorAcademico) &&
                                   !!data.cuestionariosQueVeElTutorAcademicoPendientes && data.cuestionariosQueVeElTutorAcademicoPendientes.length > 0">
                                   
        <h3 class="group-title" :style="styles.colorBasic">Encuestas pendientes</h3>

        <div class="contenedor-data -full" v-for="encuesta in data.cuestionariosQueVeElTutorAcademicoPendientes">          
          <h4 class="data-title" :style="styles.colorBasic" style="width: auto !important;">{{encuesta.valor}} -</h4>
          <a @click="solicitarMailEncuesta(encuesta.clave)" style="width: auto !important; bottom: 5px; position: relative;"
                :title="encuesta.valor" class="row-start enlace-cuestionario" :style="styles.colorBasic"
                v-if="new Date(encuesta.fechaLanzamiento) <= hoy && (encuesta.fechaLimiteContestacion == null || new Date(encuesta.fechaLimiteContestacion) >= hoy)">
                REENVIAR <only-arrow></only-arrow></a>
        </div>

      </article>
        
      <article class="group" v-if="!!brand.detallePractica.pestannaPractica.showEncuestasTutorEmpresarialPendientes &&
                                   !!data.cuestionariosTutorEmpresaParaContestar && data.cuestionariosTutorEmpresaParaContestar.length > 0">
                                   
        <h3 class="group-title" :style="styles.colorBasic">Encuestas para el tutor empresarial pendientes de contestar</h3>
        
        <div class="contenedor-data -full" v-for="encuesta in data.cuestionariosTutorEmpresaParaContestar">
          <arrow-link :text="encuesta.valor" :to="encuesta.enlace" :external="true" :blank="true">
          </arrow-link>
        </div>

      </article>
     

      <article class="group" v-if="!!data.seguimientoTutorados">

        <h3 class="group-title" v-if="!!Object.values(data.seguimientoTutorados).some(e=> !!e)"
          :style="styles.colorBasic">Seguimiento</h3>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaAsignacion">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de práctica asignada</h4>
          <p>{{data.seguimientoTutorados.fechaAsignacion}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaLimiteEntregaEstudiante">
          <h4 class="data-title" :style="styles.colorBasic">Fecha límite de entrega estudiante</h4>
          <p>{{data.seguimientoTutorados.fechaLimiteEntregaEstudiante}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaCuestionarioEstudiante">
          <h4 class="data-title" :style="styles.colorBasic">Fecha cuestionario/memoria estudiante</h4>
          <p>{{data.seguimientoTutorados.fechaCuestionarioEstudiante}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.seguimientoTutorados.fechalimiteEntregaEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">Fecha límite de entrega empresa</h4>
          <p>{{data.seguimientoTutorados.fechalimiteEntregaEmpresa}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaCuestionarioEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">Fecha cuestionario empresa</h4>
          <p>{{data.seguimientoTutorados.fechaCuestionarioEmpresa}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaMarcaEvaluacionPendiente">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de cierre pendiente</h4>
          <p>{{data.seguimientoTutorados.fechaMarcaEvaluacionPendiente}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.seguimientoTutorados.fechaMarcaEvaluacionTramitada">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de cierre tramitado</h4>
          <p>{{data.seguimientoTutorados.fechaMarcaEvaluacionTramitada}}</p>
        </div>


        <div class="contenedor-data -full" v-if="!!data.motivosSolicitudValidacion">
          <h4 class="data-title" :style="styles.colorBasic">Motivos para la solicitud de la validación</h4>
          <p>{{data.motivosSolicitudValidacion}}</p>
        </div>

      </article>

      <!-- <article class="group" v-if="!!brand.mostrarMemoria">

        <h3 class="group-title"
          :style="styles.colorBasic">Informes</h3>

          <a v-bind:href="$t('enlaces.static')+'/doc/brands/nebrija/moment/Memoria.pdf'" target="_blank"
            title="Consultar la memoria del estudiante" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Ver memoria del estudiante<only-arrow></only-arrow></a>

          <a v-bind:href="$t('enlaces.static')+'/doc/brands/nebrija/moment/ValoraEmpresa.pdf'" target="_blank"
            title="Consulta de los puntos/cuestiones valoradas por el tutor en la empresa para este estudiante" class="row-start enlace-cuestionario"
            :style="styles.colorBasic">Ver valoración de empresa<only-arrow></only-arrow></a>

      </article> -->

      <template v-if="uploaddoc">

        <article class="group -wo-flex">

          <template v-if="!!data.documentacion">


            <h2 class="ficha-title -documentacion-practica" :style="styles.colorBasic"
              v-if="data.documentacion.length> 0 || data.idEstadoValidacion == 2">Documentación del tutor/a académico/a</h2>

            <template v-for="documento in data.documentacion">
              <arrow-link-with-del @eliminar="eliminarDocumentacionPregun(documento)" :text="`${documento.nombre}`" :to="documento.enlace" :external="true" :blank="true">
              </arrow-link-with-del>
            </template>

          </template>

          <template v-if="data.idEstadoValidacion == 2">

            <a class="btn add-documentacion -xs" :style="styles.solidPrimary" @click="showAddDocumentacion('addDocumentoPractica')"
              v-if="!showadddocumentacion">Añadir documentación</a>

            <a class="btn add-documentacion -xs" :style="styles.solidPrimary" @click="showAddDocumentacion('addDocumentoPracticaParaAlumno')"
              v-if="!!data.urlDocEvaluacionTutor && !showadddocumentacion">Añadir evaluación</a>

            <add-documentacion v-if="showadddocumentacion" @setdocumentacion="setdocumentacion" :type="uploadtype" @close="closeAddDocumentacion"></add-documentacion>

          </template>

        </article>

      </template>


      <template v-if="!!data.documentacionPorPrograma && data.documentacionPorPrograma.length != 0">

        <article class="group -wo-flex">

          <h3 class="group-title" :style="styles.colorBasic">Documentación por programas</h3>

          <template v-for="documento in data.documentacionPorPrograma">

            <div class="contenedor-data -full column-start">
              <h4 class="data-title" :style="styles.colorBasic">{{documento.tituloPrograma}}</h4>
              <p>{{documento.fecha}}</p>
                <arrow-link :text="`Ver documento`" :to="documento.enlace" :external="true" :blank="true"></arrow-link>
            </div>

          </template>

        </article>

      </template>


    </template>

    <section class="cover-popup row-center" v-if="showEliminarDocumentacion" >
      <div class="popup column-center">
        <h2>¿Está seguro de que desea eliminar el documento? Esta operación no es reversible.</h2>
        <article class="group">
          <a class="btn -xs" :style="styles.solidPrimary" @click="eliminarDocumento" style="margin-top: 15px; margin-left: 5px;">Aceptar</a>
          <a class="btn -xs" :style="styles.solidPrimary" @click="showEliminarDocumentacion=false;" style="margin-top: 15px; margin-left: 5px;">Cancelar</a>
        </article>
      </div>
    </section>

  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';
  import arrowlinkWithDel from '@/components/parts/icons/arrow-link-with-del';

  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        showEliminarDocumentacion: false,
        idDocAEliminarDocumentacion: null,
        loadingGuardarDatosTutorEmpresa: false,
        uploadtype : '',
        hoy: new Date()
      }
    },
    methods: {
      ...mapActions(['cambiarTutorEmpresaPractica','solicitarCuestionario','eliminarDocumentoPractica']),
      solicitarMailEncuesta(idEncuestaPractica) {
        let data = {
          "idEncuestaPractica": idEncuestaPractica
        }
        this.solicitarCuestionario(data).then(r => {
          this.showadddocumentacion = false;
        });
      },
      setdocumentacion(value) {
        this.$emit('setDocumentoPractica', value);
        this.showadddocumentacion = false;
      },
      guardarDatosTutorEmpresa() {
        this.loadingGuardarDatosTutorEmpresa = true;
        this.cambiarTutorEmpresaPractica(this.data).then(r => {
          if (r)
            this.loadingGuardarDatosTutorEmpresa = false;
          })
      },
      showAddDocumentacion(value){
        this.showadddocumentacion = true;
        this.uploadtype = value;
      },
      closeAddDocumentacion(){
        this.uploadtype = '';
        this.showadddocumentacion = false;
      },
      eliminarDocumentacionPregun(d){
        this.showEliminarDocumentacion = true;
        this.idDocAEliminarDocumentacion = d.idDocumento;
      },
      eliminarDocumento(){
        var data = {idDOcumento: this.idDocAEliminarDocumentacion};
        this.eliminarDocumentoPractica(data).then(r => {
          if (r)
            this.showEliminarDocumentacion = false;
            this.$emit('documentoEliminado');
          })
      }

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand : 'getBrand',
        totales : 'getTotales'
      }),
      showCuestionarios(){
        let lookin = ['urlDocEvaluacionTutor','idContestacionEncuestaAlumno','idContestacionEncuestaTutorEmpresa','urlActillacalificacion','idContestacionEncuestaTutorAcademico'];
        let show = false;

        lookin.forEach(id => {
          if(!!this.data[id]){
            if (id != "idContestacionEncuestaTutorAcademico"){
              show = true;
            } else {
              //04072023 - Tarea 3519: Si la encuesta aparece en el listado de encuestas entonces no lo mostramos como cuestionario
              if (!this.data.cuestionariosQueVeElTutorAcademicoContestados.map((obj) => obj.clave).includes(this.data.idContestacionEncuestaTutorAcademico)) {
                show = true;
              }
            }
          }
        });

        if(!show && !!this.data.cuestionariosTutorAcademicoContestados){
          show = (this.data.cuestionariosTutorAcademicoContestados.length != 0)
        }

        return show;

      }
    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'arrow-link-with-del': arrowlinkWithDel,
      'add-documentacion': addDocumentacion,
    }

  }
</script>

<style scoped lang="scss">
  .enlace-cuestionario {
    font-size: 14px;
    text-transform: uppercase;
    margin-right: 5px;
    font-weight: 600;
    width: 100%;
    text-decoration: underline;
    cursor: pointer;

    svg {
      width: 15px;
      margin-left: 5px;
    }
  }

  .add-datos-tutor {
    margin-bottom: 10px;
  }

  .add-documentacion {
    margin-top: 10px;
  }

  .full-children {
    padding: 0 10px 0 0;
    margin-bottom: 0px !important;
  }

  .contenedor-input{
    margin-bottom: 0px !important;
  }

  @media screen and (max-width: 360px) {
    .enlace-cuestionario {
      font-size: 12px;
    }
  }

  .btn-delete-doc{

  }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-practica.vue